<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-03'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>Speech recognition and keyword detection in IMS core</h2>

                <p>Keyword Detection Systems (KWDs) are most used for automatic speech recognition and natural language generation and processing.</p>
                <p>Media Resource Function (MRF) capabilities in the IMS architecture enable media manipulation such as voice mixing in ongoing IMS voice calls. KWD systems may trigger an event if a keyword is detected in a voice call. This can be used to start other services, for example online translation or conference calls using the subscriber’s contact list.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>